import {CaseActions} from '../redux_constants/cases.constant';
import {searchFailed, searchInitiated} from "./search.case.action"
import {SearchAlertCaseConstant} from "../redux_constants/search.case.constant";
import {message} from "antd";
import cookie from "react-cookies";
import querystring from "query-string";
import {get, get_response, patch_response, post_response} from "../helper/request";
import {loadMorpheusSetting, updateCaseViewFilter} from './morpheus.setting.action';
import {store} from 'helper/store';
import {error_manager} from "../helper/error_manager";

export const changePage = (pageNumber) => ({
    type: CaseActions.CHANGE_PAGE_CASE,
    pageNumber: pageNumber
})

export const changeTotalNumberOfPages = (numPages) => ({
    type : CaseActions.CHANGE_TOTAL_NUMBER_OF_PAGES_CASE, 
    numPages: numPages
})

export const changeTotal = (total) => ({
    type : CaseActions.CHANGE_TOTAL_CASE, 
    total: total
})

export const allCasesLoadingSuccess = (success) => (dispatch) => {
    dispatch({
        type: CaseActions.ALL_CASES_UPDATE_SUCCESS,
        response: success
    });
    dispatch(changeTotalNumberOfPages(success.data.total_pages));
    dispatch(changePage(success.data.page_number));
    dispatch(changeTotal(success.data.count));
}

export const caseListUpdateSuccess = (id, updatedInfo) => ({
    type: CaseActions.CASE_LIST_UPDATE,
    updatedInfo: updatedInfo,
    id: id
})

export const caseListUpdateFailed = (id, error) => ({
    type: CaseActions.CASE_LIST_UPDATE_FAILED,
    response: error,
    id: id
})

export const deleteCase = (id) => ({
    type: CaseActions.CASE_LIST_DELETE,
    id: id
})

export const updateMetsSelectedSlide = (selectedSlide) => ({
    type: CaseActions.METS_SELECT_SLIDE,
    selectedSlide: selectedSlide,
})

export const loadCases = (partsOfUrl,searchInitiatedFlag=true,  isUnreadTableCollapsed=false, maxRowsAvailable=13) => dispatch => {
    if(searchInitiatedFlag){
        dispatch(searchInitiated());
    }
    dispatch(loadMorpheusSetting())
    checkStateChangeWithMorpheusSettings(partsOfUrl,store.getState().morpheusSettingReducer.case_view_filter)

    let unreadFirstCasesFlag = (partsOfUrl.ordering === "unread_first_everything_else")

    if (unreadFirstCasesFlag) {
        let partsOfUnreadFirstCasesUrl = {...partsOfUrl};
        partsOfUnreadFirstCasesUrl.ordering = "unread_first_cases";
        partsOfUnreadFirstCasesUrl.page_size = 5
        partsOfUnreadFirstCasesUrl.page=1;
        let encodedUnreadFirstCasesUrl = urlEncoder(partsOfUnreadFirstCasesUrl);
    
        if (window.location.href.split('?')[0].includes('clia_validation')) {
            encodedUnreadFirstCasesUrl += '&clia_list=true';
        }
        let unreadFirstCasesUrl = `/api/case/` + encodedUnreadFirstCasesUrl;
    
        get_response(unreadFirstCasesUrl)
            .then(firstResponse => {
                if (firstResponse.status === 200) {
    
                    let numberOfResultsUnreadTable = 0
                    if(!isUnreadTableCollapsed){
                        // added one to account for table header ( if entries present ) or all caught up message ( if no entries )
                        numberOfResultsUnreadTable = firstResponse.data.results.length + 1;
                    }
                    let pageSizeForEverythingElseTable = maxRowsAvailable - numberOfResultsUnreadTable
                    
                    partsOfUrl.page_size = pageSizeForEverythingElseTable
                    let encodedUrl = urlEncoder(partsOfUrl);
                    if (window.location.href.split('?')[0].includes('clia_validation')) {
                        encodedUrl += '&clia_list=true';
                        encodedUnreadFirstCasesUrl += '&clia_list=true';
                    }
                    let url = `/api/case/` + encodedUrl;
    
                    return get_response(url)
                        .then(secondResponse => ({
                            firstResponse,
                            secondResponse,}));
                } else {
                    dispatch(searchFailed(firstResponse));
                }
            })
            .then(({ firstResponse, secondResponse }) => {
                if(secondResponse.status === 200){
                    secondResponse.data.results = secondResponse.data.results.concat(firstResponse.data.results) 
                    dispatch(allCasesLoadingSuccess(secondResponse));
            
                    dispatch({
                        type: SearchAlertCaseConstant.CASE_UPDATE_URL_STATE,
                        urlState: {
                            ...partsOfUrl,
                            isFetching: false,  
                            page: secondResponse.data.page_number,
                            numPages: secondResponse.data.total_pages,
                            count: secondResponse.data.count
                        },
                    });
                }
                else{
                    dispatch(searchFailed(secondResponse));
                }
        })
      .catch(error => {
        if (error.response && error.response.data) {
            message.error(error.response.data.detail); 
        } else {
            message.error("An error occurred while processing your request");
        }
        dispatch(searchFailed(error));
      });
    } else {
        partsOfUrl.page_size = 15
        var encodedUrl = urlEncoder(partsOfUrl);
        if (window.location.href.split('?')[0].includes('clia_validation')) {
            encodedUrl += '&clia_list=true'
        }
        let url = `/api/case/` + encodedUrl;

        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    dispatch(allCasesLoadingSuccess(response));
                    dispatch({
                        type: SearchAlertCaseConstant.CASE_UPDATE_URL_STATE,
                        urlState: {
                            ...partsOfUrl,
                            isFetching: false,
                            page: response.data.page_number,
                            numPages: response.data.total_pages,
                            count: response.data.count
                        },
                    });
                }
                else {
                    dispatch(searchFailed(response));
                }
            })
            .catch(err => {
                dispatch(searchFailed(err));
            })
    }
}

export const checkStateChangeWithMorpheusSettings = (partsOfUrl, oldState) => {
    var stateChanged=false
    if (oldState['assigned_to_me'] !== partsOfUrl.case_assigned) {
        oldState['assigned_to_me'] = partsOfUrl.case_assigned
        stateChanged=true
    }
    if (oldState['archive_status'] !== partsOfUrl.archive_status) {
        oldState['archive_status'] = partsOfUrl.archive_status
        stateChanged=true
    }
    if (oldState['case_status'] !== partsOfUrl.case_status) {
        oldState['case_status'] = partsOfUrl.case_status
        stateChanged=true
    }
    if (oldState['read_status'] !== partsOfUrl.read_status) {
        oldState['read_status'] = partsOfUrl.read_status
        stateChanged=true
    }
    if (oldState['page'] !== partsOfUrl.page) {
        oldState['page'] = partsOfUrl.page
        stateChanged=true
    }
    if (oldState['priority'] !== partsOfUrl.priority) {
        oldState['priority'] = partsOfUrl.priority
        stateChanged=true
    }
    if(stateChanged) {
        updateCaseViewFilter(oldState)
    }
}


export const loadCaseStatus = () => dispatch => {
    let url = `/api/case_status/`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: CaseActions.UPDATE_CASE_STATUS,
                    status: response.data,
                });
            }
            else {
                dispatch(searchFailed(response));
            }
        })
        .catch(err => {
            dispatch(searchFailed(err));
        })
}

export const loadCasePriorities = () => dispatch => {
    let url = `/api/case_priority/`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: CaseActions.UPDATE_CASE_PRIORITY,
                    priorities: response.data,
                });
            }
            else {
                dispatch(searchFailed(response));
            }
        })
        .catch(err => {
            dispatch(searchFailed(err));
        })
}


export const loadCaseIDs = () => dispatch => {
    let url = `/api/get_case_ids/`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: CaseActions.UPDATE_CASE_IDS,
                    case_ids: response.data.case_ids,
                });
            }
            else {
                dispatch(searchFailed(response));
            }
        })
        .catch(err => {
            dispatch(searchFailed(err));
        })
}


export const loadUsers = () => dispatch => {
    let url = `/api/user/`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                console.log("users++", response.data)
                dispatch({
                    type: CaseActions.UPDATE_USERS,
                    users: response.data,
                });
            }
            else {
                dispatch(searchFailed(response));
            }
        })
        .catch(err => {
            dispatch(searchFailed(err));
        })
}

export const caseUpdateAlert = (id, value, selectedRows = [], get_list_data=false) => (dispatch) => {
    let url = `/api/case/${id}/?get_list_data=${get_list_data}`
    patch_response(url, value)
        .then(response => {
            if (response.status === 200 || response.status === 301 || response.status === 302) {
                response.data.displayOrder = value.displayOrder;
                dispatch(caseListUpdateSuccess(id, response.data));
                if(selectedRows.length > 0 && id === selectedRows[selectedRows.length - 1]) {
                    message.success("Case/Cases Successfully Updated");
                }
            }
            else if (response.status === 403 || response.status === 401 || response.status === 400) {
                // dispatch(caseListUpdateFailed(id, response));
            }
        })
        .catch(err => {
            error_manager("Failed to update Case/Cases", err)
            // dispatch(caseListUpdateFailed(id, err));
        });
}

/**
 * @deprecated
 * TODO: [Spandan] Remove this function, url no longer exist in backend
 * Active function: assignCaseToGroups
 */
export const assignUsersUpdateAlert = (ids, values, assigned_users, selectedRows = []) => (dispatch) => {
    let url = `/api/assign_users_to_case/`;
    post_response(url, querystring.stringify({'ids':ids, 'assigned_users':assigned_users, 'notify_assigned_users':cookie.loadAll().notify_assigned_users}))
        .then(response => {
            if (response.status === 200 || response.status === 301 || response.status === 302) {
                for(let i=0; i<ids.length; i++){
                    dispatch(getCase(ids[i], values[i], selectedRows));
                }
            }
            else if (response.status === 403 || response.status === 401 || response.status === 400) {
                // dispatch(caseListUpdateFailed(id, response));
            }
        })
        .catch(err => {
            // dispatch(caseListUpdateFailed(id, err));
        });
}

/**
 * @deprecated
 * TODO: [Spandan] Remove this function, url no longer exist in backend
 * Active function: assignCaseToGroups
 */
export const removeUserUpdateAlert = (id, value, urlState) => (dispatch) => {
    let url = `/api/remove_user_from_case/`;
    
    post_response(url, querystring.stringify(value))
        .then(response => {
            if (response.status === 200 || response.status === 301 || response.status === 302) {
                if((urlState.case_assigned || urlState.unread || urlState.read) && cookie.loadAll().user_id === value.user_id) {
                    dispatch(deleteCase(id));
                } else {
                    dispatch(getCase(id, value));
                }
                message.success("User successfully deleted from the case");
            }
            else if (response.status === 403 || response.status === 401 || response.status === 400) {
                // dispatch(caseListUpdateFailed(id, response));
            }
        })
        .catch(err => {
            // dispatch(caseListUpdateFailed(id, err));
        });
}

export const getCase = (id, value, selectedRows = [], get_list_data=false) => (dispatch) => {
    let url = `/api/case/${id}/?&get_list_data=${get_list_data}`

    const allCases = store.getState().casesReducer;
    if (allCases.hasOwnProperty(id)) {
        const caseObject = allCases[id];
        if (caseObject && caseObject.hasOwnProperty('days_unread_since')) {
            url += '&unread_first=true';
        }
    }
    
    get_response(url)
        .then(response => {
            if (response.status === 200 || response.status === 301 || response.status === 302) {
                response.data.displayOrder = value.displayOrder;
                dispatch(caseListUpdateSuccess(id, response.data));
                if(selectedRows.length > 0 && id === selectedRows[selectedRows.length - 1]) {
                    message.success("Case/Cases Successfully Updated");
                }
            }
            else if (response.status === 403 || response.status === 401 || response.status === 400) {
                // dispatch(caseListUpdateFailed(id, response));
            }
        })
        .catch(err => {
            // dispatch(caseListUpdateFailed(id, err));
        });
}

export const markCaseUnread = (curr_case) => dispatch => {
    let url = `/api/make_case_unread/?case_id=${curr_case.id}`
    get_response(url)
        .then(response => {
            if (response.status === 200 || response.status === 301 || response.status === 302) {
                dispatch(getCase(curr_case.id, curr_case, [], true));
            }
            else if (response.status === 403 || response.status === 401 || response.status === 400) {
                // dispatch(caseListUpdateFailed(id, response));
            }
        })
        .catch(err => {
            // dispatch(caseListUpdateFailed(id, err));
        });
}

export const markCaseRead = (curr_case, onlyUpdateStatus) => dispatch => {
    let url = `/api/make_case_read/?case_id=${curr_case.id}`
    get_response(url)
        .then(response => {
            if (!onlyUpdateStatus) {
                if (response.status === 200 || response.status === 301 || response.status === 302) {
                    dispatch(getCase(curr_case.id, curr_case, [], true));
                }
                else if (response.status === 403 || response.status === 401 || response.status === 400) {
                    // dispatch(caseListUpdateFailed(id, response));
                }
            }
        })
        .catch(err => {
            // dispatch(caseListUpdateFailed(id, err));
        });
}

export const urlEncoder = (partsOfUrl) => {
    var encodedUrl = '?';
    if (partsOfUrl === undefined) {
        return encodedUrl;
    }
    if ('folder' in partsOfUrl) {
        encodedUrl += partsOfUrl.folder !== '' ? `&patient_folder=${partsOfUrl.folder}` : ''
    }
    if ('search' in partsOfUrl) {
        encodedUrl += partsOfUrl.search !== '' ? '&search=' + partsOfUrl.search : '';
    }
    if ('case_assigned' in partsOfUrl) {
        encodedUrl += partsOfUrl.case_assigned ? '&case_assigned=true' : '';
    }
    if ('read_status' in partsOfUrl) {
        encodedUrl += '&read_status=' + partsOfUrl.read_status;
    }
    if ('ordering' in partsOfUrl) {
        encodedUrl += '&ordering=' + partsOfUrl.ordering;
    }
    if ('page' in partsOfUrl) {
        encodedUrl += '&page=' + partsOfUrl.page;
    }
    if ('validation_id' in partsOfUrl){
        encodedUrl += '&validation_id=' + partsOfUrl.validation_id;
    }
    if ('type' in partsOfUrl){
        encodedUrl += '&type=' + partsOfUrl.type
    }
    if ('date__gte' in partsOfUrl) {
        encodedUrl += '&date__gte='+partsOfUrl.date__gte;
    }
    if ('date__lte' in partsOfUrl) {
        encodedUrl += '&date__lte='+partsOfUrl.date__lte;
    }
    if ('priority' in partsOfUrl) {
        encodedUrl += '&priority='+partsOfUrl.priority;
    }
    if ('case_status' in partsOfUrl) {
        encodedUrl += '&case_status='+partsOfUrl.case_status;
    }
    if ('archive_status' in partsOfUrl) {
        encodedUrl += '&archive_status='+partsOfUrl.archive_status;
    }
    if('page_size' in partsOfUrl){
        encodedUrl += '&page_size='+partsOfUrl.page_size;
    }
    return encodedUrl;
}


export const getAdjacentCases = (caseId, slideId, successCallback) => {
    const url = `/api/get_adjacent_cases/?slide_id=` + slideId + "&case_id=" + caseId + "&morpheus_setting_id="
        + JSON.parse(localStorage.getItem('morpheus_setting')).id;
    get(url)
        .then(result => successCallback(result))
        .catch(err => error_manager("Failed to load adjacent cases", err))
}